/**
 * Компьютерная раскладка (просьба пользователя 21.10.2026: «десктоп-версия, когда открываешь с Telegram
 * Desktop»). Раскладку выбирает ШИРИНА окна, а не платформа: окно мини-аппа в Telegram Desktop по умолчанию
 * узкое, как телефон, — в нём остаётся телефонная раскладка; растянутое или развёрнутое на весь экран —
 * боковое меню и широкий контент. Пороги — правило «до 1024 px — нижнее меню» (память, проверка на 6 ширинах).
 */
import { useEffect, useState } from 'react'

/** Боковое меню вместо нижнего, контент шире. */
export const WIDE_QUERY = '(min-width: 1024px)'
/** Две колонки на «Сводке», в калькуляторе, в «Прибыли за период», в карточке товара. */
export const TWO_COL_QUERY = '(min-width: 1280px)'

export function useMedia(query: string): boolean {
  const [on, setOn] = useState(() => typeof window.matchMedia === 'function' && window.matchMedia(query).matches)
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return
    const mq = window.matchMedia(query)
    const sync = (): void => setOn(mq.matches)
    sync()
    mq.addEventListener('change', sync)
    return () => mq.removeEventListener('change', sync)
  }, [query])
  return on
}

export const useWide = (): boolean => useMedia(WIDE_QUERY)
export const useTwoCols = (): boolean => useMedia(TWO_COL_QUERY)
